import React from 'react';
import cls from 'classnames';

import {
  IAvailableOption,
  IAvailableVariance,
  INextShippingOption,
} from 'src/explore/types/shoppe';

import { Shipping } from './elements/Shipping';

interface GetItByProps {
  acceptsRequests: boolean;
  canUpgrade: boolean;
  className?: {
    container?: string;
    date?: string;
  };
  isAvailable: boolean;
  maxDays: number;
  nextShippingOption: INextShippingOption;
  productId: number;
  withMoreDates?: boolean;
  choices?: IAvailableOption[];
  options?: IAvailableVariance[];
  quantity?: number;
}

export const GetItBy = ({
  acceptsRequests,
  className = {},
  isAvailable,
  maxDays,
  nextShippingOption,
  productId,
  withMoreDates = false,
  choices = [],
  options = [],
  quantity = 1,
}: GetItByProps ) => {
  if ( !isAvailable || !nextShippingOption ) {
    return null;
  }

  return (
    <div
      className={cls(
        'product__delivery-options pt-4 mt-4 mx-auto fs-5 text-center spec__delivery-options',
        className.container
      )}
    >
      <Shipping
        acceptsRequests={acceptsRequests}
        className={className}
        maxDays={maxDays}
        nextShippingOption={nextShippingOption}
        productId={productId}
        withMoreDates={withMoreDates}
        choices={choices}
        options={options}
        quantity={quantity}
      />
    </div>
  );
};
